import * as amplitude from '@amplitude/analytics-browser'
import type { BrowserOptions } from '@amplitude/analytics-types'

export const initAmplitude = (options?: BrowserOptions): void => {
  amplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY as string, options)
}
